import React from 'react';
import { motion } from 'framer-motion';
export function IdentitySection() {
  return <section className="py-32 bg-primary text-center" data-id="element-103">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-105">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-text-primary mb-8 leading-tight" data-id="element-106">
            Look Polished. <br data-id="element-107" />
            Feel Confident. <br data-id="element-108" />
            <span className="text-accent" data-id="element-109">Show Up Intentional.</span>
          </h2>
          <p className="text-xl text-text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-110">
            The right fit changes everything. Not just how clothes look—how you
            feel wearing them. When proportions are correct, you look like the
            adult, confident, intentional person you are.
          </p>
        </motion.div>
      </div>
    </section>;
}